module.exports = __webpack_public_path__ + "img/002d5a4.png";